module.exports = __webpack_public_path__ + "img/bwc_wechat.d6141ed0.png";